import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { TypeAnimation } from 'react-type-animation';
import bannerimg from '../../../images/bannarimg.png';
import './BannerSection.css';


const BannerSection = () => {
    return (
        <div className="max-w-7xl mx-auto px-6 pt-20">
            <div className="grid lg:grid-cols-3 gap-12 items-center mx-5">
                <div className=" lg:mt-0 lg:col-span-2">
                    <h1 className="text-md font-semibold tracking-widest mb-4 text-[#BBC6D4]">WELCOME TO MY WORLD</h1>
                    <h1 className="text-4xl md:text-5xl xl:text-7xl font-bold tracking-tight mb-8 text-[#FFFFFF]">Hi, I'm <span className='text-[#ff014f]'>Md Shijan Ali</span>  <br /></h1>
                    <h1><span className="text-[#ff014f] text-4xl tracking-wide font-bold">A
                        <TypeAnimation
                            // Same String at the start will only be typed once, initially
                            sequence={[
                                ' Professional MERN Stack Developer',
                                2000,
                                ' Professional MEVN Stack Developer',
                                2000,
                                ' Junior Web Developer',
                                2000,
                                ' Junior Software Engineer',
                                2000,
                                ' Software Engineer',
                                2000,
                                ' Front End Developer',
                                2000,
                                ' Web Developer',
                                2000,
                                ' WordPress Developer',
                                2000,
                            ]}
                            speed={0} // Custom Speed from 1-99 - Default Speed: 40

                            wrapper="span" // Animation will be rendered as a <span>
                            repeat={Infinity} // Repeat this Animation Sequence infinitely
                        />
                    </span></h1>
                    <p className='text-md font-semibold tracking-wide lg:mr-20 mt-8 mb-4 text-[#BBC6D4]'>
                        I'm a Professional Jr. Software Engineer. I have studied and worked in this field last 4 years+. I have completed more than 100+  projects using MERN and MEVN Stack and 50+ projects using WordPress and Worked Marketing for my International Clients Business.
                    </p>
                    <a href='https://drive.google.com/file/d/198ibHCfqRb0BwrdcipthwS0zffFjEatE/view?usp=sharing' target='_blank' rel="noreferrer" className='btn btn-md mt-5 shadow-lg shadow-slate-600'>Download Resume <ArrowDownTrayIcon className='h-6 w-6 text-[#BBC6D4] ml-2'></ArrowDownTrayIcon> </a>


                    <div className='mt-24'>
                        <h3 className='text-md tracking-wide my-4 text-[#BBC6D4]'>FIND WITH ME</h3>
                        <div className=' flex gap-6'>
                            <div className='group shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                                <a href="https://facebook.com/mdshijanali135" target='_blank' rel="noreferrer"><FaFacebookF className='w-6 h-6 text-[#BBC6D4] group-hover:text-[#ff014f]'></FaFacebookF></a>
                            </div>
                            <div className='group shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                                <a href="https://twitter.com/shijan135" target='_blank' rel="noreferrer"><FaTwitter className='w-6 h-6 text-[#BBC6D4] group-hover:text-[#ff014f]'></FaTwitter></a>
                            </div>
                            <div className='group shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                                <a href="https://linkedin.com/in/mdshijanali" target='_blank' rel="noreferrer"><FaLinkedinIn className='w-6 h-6 text-[#BBC6D4] group-hover:text-[#ff014f]'></FaLinkedinIn></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" lg:col-span-1 box">
                    <img
                        src={bannerimg}
                        className="w-full shadow-slate-600 rounded-lg shadow-lg"
                        alt=""
                    />
                </div>
            </div>
            <div className="divider mt-20"></div>
        </div>





    );
};

export default BannerSection;